import { render, staticRenderFns } from "./SampleValidationChemical.vue?vue&type=template&id=6c8d8461&scoped=true"
import script from "./SampleValidationChemical.vue?vue&type=script&lang=js"
export * from "./SampleValidationChemical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8d8461",
  null
  
)

export default component.exports